/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 21st 2022, 4:54:32 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { Team, TaskTemplate } from "lib/schemas";
import GroupsIcon from "@mui/icons-material/Groups";
import Stack from "@mui/material/Stack";
import { useServiceBuilderContext } from "service-builder/providers";
import { EmphasisText, useToggleState, OSActionButton } from "ui-widgets";
import { TaskAllowedTeamsList } from "./TaskAllowedTeamsList";
import { TaskAccessForm } from "./TaskAccessForm";

interface TaskAccessSettingsProps {
  taskTemplate: TaskTemplate;
}

export const TaskAccessSettings = ({ taskTemplate }: TaskAccessSettingsProps) => {
  const [chosenTeam, setChosenTeam] = React.useState<Team>();

  const [reloadTeamsListSignal, setReloadTeamsListSignal] = React.useState<number>(0);

  const { handleClose, handleOpen, open } = useToggleState();

  const taskPermissionIds = taskTemplate?.permissions;
  const taskTitle = taskTemplate?.title;

  const openTeamAccessForm = (team: Team) => {
    setChosenTeam(team);
    handleOpen();
  };

  const {
    patchCurrentProcessDefinition,
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  const onUpdateTeamsPermissions = (team: Team) => {
    setReloadTeamsListSignal((prev) => prev + 1);
    patchCurrentProcessDefinition({ groups: [...currentProcessDefinition.groups, team.group] });
    handleClose();
  };

  return (
    <>
      <Stack spacing={2}>
        <OSActionButton actionStyle="custom" customIcon={<GroupsIcon />} onClick={() => openTeamAccessForm(null)}>
          Give a team access to <EmphasisText style={{ padding: "0px 5px 0px 5px" }}>{taskTitle}</EmphasisText>
        </OSActionButton>
        <div>
          <TaskAllowedTeamsList
            allowedTeamsFecthDepArray={[reloadTeamsListSignal]}
            permissionIds={taskPermissionIds as number[]}
            openTeamAccessForm={openTeamAccessForm}
            taskTemplate={taskTemplate}
          />
        </div>
      </Stack>
      <TaskAccessForm
        taskTemplate={taskTemplate}
        onUpdateTeamsPermissions={onUpdateTeamsPermissions}
        open={open}
        handleFormClose={handleClose}
        setChosenTeam={setChosenTeam}
        chosenTeam={chosenTeam}
      />
    </>
  );
};
